import getBusinessTypeName from '../../utils/getBusinessTypeName';
import type { ValueGetterParams } from 'ag-grid-community';
import type { OptionsType } from '../../types/options';
import type { BusinessType, Language, SelectOption } from '../../types/common';

/**
 * businessType[]からフィルタ用の文字列を生成する。
 * contextにcurrentLang, businessTypeが存在する必要がある。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const businessTypeFilterValueGetter = (params: ValueGetterParams) => {
  const value: BusinessType | BusinessType[] = params.getValue('businessType');
  const businessTypeCodes: BusinessType[] = Array.isArray(value) ? value : [value];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const businessType: OptionsType<BusinessType>[] | undefined = params.context?.businessType;
  // 区分の配列を区分名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
  const businessTypeNames: string[] = businessTypeCodes.map((code) => {
    const businessTypeName: string = getBusinessTypeName(code, businessType, currentLang.value);
    return businessTypeName;
  });
  const filterValue: string = businessTypeNames.join(', ');
  return filterValue;
};

export default businessTypeFilterValueGetter;
